import React, {Component} from "react";
import FadeIn from 'react-fade-in';

class Learn extends Component {

	pageContent(title) {
		
		return(
		<div className="arrival">
		      		      
			<h1 className="font-weight-light">{title}</h1>
	        
        	<div className="dt-bk-color-light">  	
      		<div className="container dt-container ">
        	<div className="row align-items-center">
    	
				<div className="col-lg-6 col-sm-12">
				    <p className="dt-text-large">
				    Personalized Therapy Sessions
				    </p>
				    <p>
				    At Diane Taylor, MFT Associate, I offer personalized therapy sessions. 
				    I believe therapy should feel safe, collaborative, and empowering. 
				    My approach blends evidence-based techniques with a warm, 
				    non-judgmental style. I work with clients to identify patterns, 
				    build practical skills, and create lasting change.
				    </p>
				 </div>
				          
				<div className="col-lg-6 col-sm-12">
				    <img
				      className="sj-img img-fluid rounded mb-4 mb-lg-0"
				      src={global.config.imgs.banner2}
				      alt=""
				    />
				</div> 
      	
      			<div className="col-lg-12">
		          	<br/>
      				<br/>
      				<br/>
		        </div>
      			      			
      		</div>
    		</div>  
	        </div>		     
		    
		    <div className="container dt-container ">
		    
		    	<div className="row align-items-center my-5">
		        	<div className="col-lg-12 col-sm-12">
				        <p className="dt-text-large text-center">
				        Services
				        </p>
						<p>
						<b>Individual Therapy</b><br/>
						Support for trauma, anxiety, stress, depression, self-esteem, 
						and life transitions. Together we’ll work to build 
						coping skills and deeper self-understanding.
						</p>
						<p>
						<b>Family Therapy</b><br/>
						Address family conflict, parenting challenges, 
						and major transitions. Family sessions focus on 
						improving communication and fostering understanding.
						</p>
						<p>
						<b>Couples Counseling</b><br/>
						Improve communication, rebuild trust, and 
						strengthen emotional connection. I help couples 
						navigate conflict and create healthier relationship patterns.
						</p>
						<p>
						<b>Specialties</b><br/>
						<ul>
							<li>Teens</li>
							<li>Women</li>
							<li>Trauma</li>					
							<li>Anxiety & Stress</li>
							<li>Relationship Issues</li>
							<li>Parenting Support</li>
							<li>Life Transitions</li>
							<li>Communication Skills</li>
							<li>Conflict Resolution</li>
						</ul>
						</p>						
					</div>	        
		        </div>
		        
				<div className="col-lg-12">
	          		<hr />
	          	</div> 
	          	
	          	<div className="row align-items-center my-5">
		        	<div className="col-lg-12 col-sm-12">
						<p>
						<b>My Approach</b><br/>
						I use a collaborative and strengths-based 
						approach grounded in evidence-based practices. 
						Therapy with me focuses on:
						<ul>
							<li>Understanding relationship patterns</li>
							<li>Improving communication skills</li>
							<li>Building emotional awareness</li>
							<li>Developing practical coping strategies</li>
							<li>Creating sustainable change</li>
						</ul>
						Sessions are tailored to your goals, and we 
						move at a pace that feels comfortable for you.
						</p>					
					</div>	        
		        </div>
		        
				<div className="col-lg-12">
	          		<hr />
	          	</div> 
	          	
	          	<div className="row align-items-center my-5">
		        	<div className="col-lg-12 col-sm-12">
						<p>
						<b>What to Expect</b><br/>
						Starting therapy can feel like a big step. 
						In our first session, we’ll discuss your goals, 
						current challenges, and what you hope to gain 
						from therapy. From there, we’ll create a plan 
						that supports meaningful progress.
						</p>
						<p>
						Sessions are:
						<ul>
							<li>Confidential</li>
							<li>Supportive and non-judgmental</li>
							<li>Goal-focused</li>
							<li>Tailored to your needs</li>
						</ul>
						Sessions are tailored to your goals, and we 
						move at a pace that feels comfortable for you.
						</p>					
					</div>	      
				</div>
					
				<div className="row align-items-center my-5">
					<div className="col-lg-12 col-sm-12 d-flex justify-content-center">    
	        	
				        <div class="toast show">
						  <div class="toast-header">
						    Meet Knox
						  </div>
						  <div class="toast-body row">
						  	<div class="col-md-6 text-center">
							    <img
							      className="sj-custom-image img-fluid rounded mb-4 mb-lg-0"
							      src={global.config.imgs.banner3}
							      alt="Knox"
							    />
							</div>
							<div class="col-md-6 d-flex align-items-center">
							    <p>Knox is a certified therapy dog.  He is available 
							    during sessions as needed. 
							    </p>
							</div>
						  </div>
						</div>
						
					</div>
				</div>

		    </div>
		    	
		</div>
		);
	}

    render() {
			
		document.title = global.config.pageTitles.learn + 
							global.config.pageTitles.seperator +
							global.config.pageTitles.title;	
			
		let title = global.config.pageTitles.learn;

        return (
            this.pageContent(title)
        );
        
    }

}

export default Learn;

    
